import { CacheConfig, CacheStatus, getCachedItem, setCacheItem, setCacheStatus } from "@r-and-a-shared-ui/core-caching";
import { Article } from "../models/MEMBERSHIP";
import { DynamicRecommendedArticles } from "@r-and-a-shared-ui/utils";
import { deliveryClient } from "../config/kontent-delivery-client";
import { adjustSystemProperties } from "../utils";

type GetExcludedArticlesResponse = {
  queryUrl: string;
  items: Article[];
};

type GetExcludedArticlesProps = {
  [key: string]: string[] | DynamicRecommendedArticles | boolean;
};

export const getArticlesWithExclusion = async (
  props: GetExcludedArticlesProps,
  cache = true,
  cacheTTL = CacheConfig.TTL.PageElement.valueOf(),
  cacheStatus?: CacheStatus
) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const cacheKey = `getExcludedArticles-${JSON.stringify(props)}`;
    const cachedItem = getCachedItem<GetExcludedArticlesResponse>(cacheKey);

    if (cachedItem) {
      setCacheStatus(cacheStatus, {
        cacheable: cache,
        xInMemoryCache: CacheConfig.Hit,
        cacheTTL
      });
      return cachedItem;
    }
    
    const pageSize =  props['filtersToExclude']
      ? (props['filtersToExclude'] as DynamicRecommendedArticles).pagination.pageSize
      : 0;
    const pageNumber =  props['filtersToExclude']
      ? (props['filtersToExclude'] as DynamicRecommendedArticles).pagination.pageNumber
      : 0;
    const excludedArticles = props['filtersToExclude']
      ? (props['filtersToExclude'] as DynamicRecommendedArticles).filtersToExclude
      : [];
      
    const query = deliveryClient
      .items<Article>()
      .type('article')
      .depthParameter(1);

    query
      .notInFilter('elements.url_slug', excludedArticles)
      .orderParameter('elements.publish_date', 'desc');

    const queryText = query.getUrl();

    const data = await query
      .limitParameter(pageSize)
      .skipParameter(pageNumber * pageSize)
      .includeTotalCountParameter()
      .toPromise().then(r => r.data);

    adjustSystemProperties(data);

    const { items } = data;

    const response = {
      queryUrl: queryText,
      items,
    };

    setCacheItem<GetExcludedArticlesResponse>(cacheKey, response, cacheTTL, cache);

    setCacheStatus(cacheStatus, {
      cacheable: cache,
      xInMemoryCache: CacheConfig.Miss,
      cacheTTL
    });

    return response;
  } catch (error) {
    throw error;
  }
};